import * as _ from "lodash";
import * as log from "loglevel";

import { action, autorun, computed, observable, runInAction } from "mobx";
import { config } from "../config";
import { Agent } from "../services/agent";
import { App } from "./models/app";
import { Project } from "./models/project";
import { ProjectApp } from "./models/project-app";
import { User } from "./models/user";

export class ProjectAppStore {
	@observable projectApps: ProjectApp[] = [];
	@observable loading = false;
	@observable saving = false;


	constructor(){
	}

	@action async loadProjectApps(projectId: string){
		log.debug("LoadProjectApps (store)");
		this.loading = true;
		let appData = await Agent.ProjectApps.get(projectId);

		runInAction(() => {
			this.projectApps = appData.map((result : any) => {
				return new ProjectApp(result);
			});
			this.loading = false;
		});
	}

	@action async create(pa: ProjectApp){
		await Agent.ProjectApps.create(pa);
		await this.loadProjectApps(pa.projectId);
	}

	@action async remove(pa: ProjectApp) {
		await Agent.ProjectApps.remove(pa.id);
		await this.loadProjectApps(pa.projectId);
	}
}



// WEBPACK FOOTER //
// ./src/stores/project-app-store.ts